import { useMemo } from 'react';
import { useHookSubscribe } from '../../react-rxjs';
import { useMapDimension } from './useMapDimension';
import { useMapStore } from './useMapStore';

export function useMapCountryDimension() {
  const store = useMapStore();
  const dimensions = useHookSubscribe([], store.dimensions$);
  const countriesDim = useMemo(() => dimensions.find(e => e.visible && e.hierarchy.includes('countries')), [dimensions]);
  const { loading: loadingDimCountries, value: selectedCountryId, items: countries } = useMapDimension(countriesDim);
  const loadingDataSources = useHookSubscribe(false, store.loadingDataSources$);
  const loadingDimensions = useHookSubscribe(false, store.loadingDimensions$);
  const loadingCountryDimension = loadingDataSources || loadingDimensions || loadingDimCountries;
  const selectedCountry = useMemo(() => countries.find((e) => e.data.getValue('id') === selectedCountryId), [countries, selectedCountryId]);
  return {
    loadingCountryDimension, countries, selectedCountryId, selectedCountry
  }
}